/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `Audit.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { Audit } from "./Audit";

import { User } from "./User";

export abstract class AuditModel {
    id: number;
    auditableId: number;
    auditableType: string;
    change: string | null;
    createdAt: Dayjs;
    updatedAt: Dayjs;
    userId: number | null;
    user: User | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        auditableId: number,
        auditableType: string,
        change: string | null,
        createdAt: Dayjs,
        updatedAt: Dayjs,
        userId: number | null,
        user: User | null | undefined
    ) {
        this.id = id;
        this.auditableId = auditableId;
        this.auditableType = auditableType;
        this.change = change;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.userId = userId;
        this.user = user;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): Audit {
        const newObject = new Audit(
            json["id"],
            json["auditable_id"],
            json["auditable_type"],
            json["change"],
            dayjs(json["created_at"]).tz(timezone),
            dayjs(json["updated_at"]).tz(timezone),
            json["user_id"],
            json["user"] == null ? json["user"] : User.fromApiObject(json["user"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            auditable_id: this.auditableId,
            auditable_type: this.auditableType,
            change: this.change,
            created_at: this.createdAt,
            updated_at: this.updatedAt,
            user_id: this.userId,
            user_attributes: this.user?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): Audit {
        const clone = Object.create(this) as Audit;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
